import type { FlowType } from "conversion_flows/types/scalars"
import type ModuleTypes from "website_script/constants/ModuleTypes"
import type { Texts } from "./texts"
import type { Theme } from "./theme"
import type { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme"
import type { Settings } from "./settings"
import type { FlowsContext } from "website_script/contexts/flows"
import type { Environment } from "./environment"
import appStore from "website_script/stores/app"
import wrapperElStore from "website_script/stores/wrapper"

export enum CallbackNames {
  onValuationDone = "onValuationDone",
  onValuationFailed = "onValuationFailed",
  onFormOpen = "onFormOpen",
  onCarDetailsStarted = "onCarDetailsStarted",
  onCarDetailsSent = "onCarDetailsSent",
  onCustomerDetailsSent = "onCustomerDetailsSent",
  onUnavailable = "onUnavailable",
  onBookTestDriveStarted = "onBookTestDriveStarted",
  onBookTestDriveDone = "onBookTestDriveDone",
  onFlowStatusKnown = "onFlowStatusKnown",
  /**
   * Generic lead flow events
   */
  /** When the lead flow is opened in a modal */
  onLeadFlowOpened = "onLeadFlowOpened",
  /** When the lead flow is first opened */
  onLeadFlowStarted = "onLeadFlowStarted",
  /** When the lead details are submitted by the user (but not necessarily verified) */
  onLeadFlowSubmitted = "onLeadFlowSubmitted",
  /** Deprecated, please use onLoadFlowCompleted */
  onLeadFlowDone = "onLeadFlowDone",
  /** When the lead is ready to be delivered to the dealer (verified) */
  onLeadFlowCompleted = "onLeadFlowCompleted",
}
type ConfigCallbacks = {
  [k in CallbackNames]?: (details: unknown) => void
}

export type Config = {
  id: string
  departmentId?: string
} & ConfigCallbacks

export type OpenModalOpts = {
  sellerUrl?: string
  customData?: Record<string, string | number>
  stockId?: string | null
  integrationId?: string | null
  conversionFlow?: FlowType
  departmentId?: string | null
  leadFlowId?: number
}

export type CustomModalOpts = {
  detail: {
    /** Defines what module should be opened */
    moduleType: ModuleTypes
    /** Defines extra options for opening the module */
    opts?: OpenModalOpts
  }
}

export type AppContexts = {
  config: Config
  texts: Texts
  theme: Theme
  dealerTheme: DealerTheme
  settings: Settings
  flows: FlowsContext
  environment: Environment
  appStore: typeof appStore
  wrapperElStore: typeof wrapperElStore
}
